export const ENTRIES = [
{
name: "Megan Eggert",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Collin Morikawa",
	"Xander Schauffele",
	"Brooks Koepka"
],
tiebreaker: -11
},
{
name: "Ray DelFava",
golfers: [
	"Scottie Scheffler",
	"Jon Rahm",
	"Wyndham Clark",
	"Ludvig Aberg",
	"Joaquin Niemann"
],
tiebreaker: -13
},
{
name: "George Eggert",
golfers: [
	"Scottie Scheffler",
	"Hideki Matsuyama",
	"Collin Morikawa",
	"Tom Kim",
	"Sahith Theegala"
],
tiebreaker: -13
},
{
name: "Rob Lantz",
golfers: [
	"Scottie Scheffler",
	"Jon Rahm",
	"Brooks Koepka",
	"Hideki Matsuyama",
	"Wyndham Clark"
],
tiebreaker: -8
},
{
name: "Al Shapiro",
golfers: [
	"Hideki Matsuyama",
	"Brooks Koepka",
	"Viktor Hovland",
	"Dustin Johnson",
	"Tommy Fleetwood"
],
tiebreaker: -9
},
{
name: "Ron Fortman",
golfers: [
	"Scottie Scheffler",
	"Jon Rahm",
	"Sahith Theegala",
	"Joaquin Niemann",
	"Matt Fitzpatrick"
],
tiebreaker: -16
},
{
name: "Ernie Cervantes",
golfers: [
	"Xander Schauffele",
	"Jon Rahm",
	"Will Zalatoris",
	"Patrick Cantlay",
	"Scottie Scheffler"
],
tiebreaker: -9
},
{
name: "Matt Shapiro",
golfers: [
	"Rory McIlroy",
	"Xander Schauffele",
	"Jordan Spieth",
	"Will Zalatoris",
	"Sahith Theegala"
],
tiebreaker: -9
},
{
name: "Karl Stevens",
golfers: [
	"Scottie Scheffler",
	"Jon Rahm",
	"Brooks Koepka",
	"Joaquin Niemann",
	"Bryson DeChambeau"
],
tiebreaker: -15
},
{
name: "Marc Camardo",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Jon Rahm",
	"Xander Schauffele",
	"Jordan Spieth"
],
tiebreaker: -9
},
{
name: "David Hess",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Viktor Hovland",
	"Jon Rahm",
	"Xander Schauffele"
],
tiebreaker: -11
},
{
name: "Roger VanWazer",
golfers: [
	"Rory McIlroy",
	"Sahith Theegala",
	"Matt Fitzpatrick",
	"Cameron Young",
	"Shane Lowry"
],
tiebreaker: -10
},
{
name: "Mark Schmid",
golfers: [
	"Scottie Scheffler",
	"Will Zalatoris",
	"Xander Schauffele",
	"Brooks Koepka",
	"Hideki Matsuyama"
],
tiebreaker: -13
},
{
name: "Brian Wade",
golfers: [
	"John Rahm",
	"Hideki Matsuyama",
	"Scottie Scheffler",
	"Jordan Spieth",
	"Russell Henley"
],
tiebreaker: -10
},
{
name: "Tom Arndt",
golfers: [
	"Rory McIlroy",
	"Hideki Matsuyama",
	"Brooks Koepka",
	"Scottie Scheffler",
	"Bryson DeChambeau"
],
tiebreaker: -8
},
{
name: "Jay LaMar",
golfers: [
	"Scottie Scheffler",
	"Joaquin Niemann",
	"Rory McIlroy",
	"Corey Conners",
	"Sungjae Im"
],
tiebreaker: -14
},
{
name: "Tony Fasuna",
golfers: [
	"Scottie Scheffler",
	"John Rahm",
	"Brooks Koepka",
	"Xander Schauffele",
	"Wyndham Clark"
],
tiebreaker: -11
},
{
name: "Pete Majeski",
golfers: [
	"Corey Conners",
	"Scottie Scheffler",
	"Tom Kim",
	"Brooks Koepka",
	"Wyndham Clark"
],
tiebreaker: -11
},
{
name: "Danni Shapiro",
golfers: [
	"Scottie Scheffler",
	"Will Zalatoris",
	"Matt Fitzpatrick",
	"Tiger Woods",
	"Collin Morikawa"
],
tiebreaker: -11
},
{
name: "Nick Morini",
golfers: [
	"Scottie Scheffler",
	"Brooks Koepka",
	"Xander Schauffele",
	"Rory McIlroy",
	"Hideki Matsuyama"
],
tiebreaker: -9
},
{
name: "Matt Majeski",
golfers: [
	"Tommy Fleetwood",
	"Rory McIlroy",
	"Shane Lowry",
	"Brooks Koepka",
	"Max Homa"
],
tiebreaker: -11
},
{
name: "Scott Zimmerman",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Jon Rahm",
	"Brooks Koepka",
	"Xander Schauffele"
],
tiebreaker: -9
},
{
name: "Art Ramos #1",
golfers: [
	"Scottie Scheffler",
	"Rory McIlroy",
	"Jon Rahm",
	"Will Zalatoris",
	"Viktor Hovland"
],
tiebreaker: -11
},
{
name: "Art Ramos #2",
golfers: [
	"Scottie Scheffler",
	"Brooks Koepka",
	"Jon Rahm",
	"Xander Schauffele",
	"Hideki Matsuyama"
],
tiebreaker: -13
},
{
name: "Mike Donoghue",
golfers: [
	"Jordan Spieth",
	"Scottie Scheffler",
	"Hideki Matsuyama",
	"Collin Morikawa",
	"Brooks Koepka"
],
tiebreaker: -18
},
{
name: "Connie Wade",
golfers: [
	"Scottie Scheffler",
	"Xander Schauffele",
	"Brooks Koepka",
	"Jon Rahm",
	"Will Zalatoris"
],
tiebreaker: -12
},


]